 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"6f3d461a","chunk-19bd66b2":"efce8f94","chunk-2d0a3596":"6282e71b","chunk-2d0b2d29":"35a1012d","chunk-2d0b6969":"e2145248","chunk-2d0c4d85":"4f643a7b","chunk-16d3d0f6":"bf49208a","chunk-27e95ab0":"79c74766","chunk-2d0c7ca9":"39355926","chunk-e4733816":"a7f7400f","chunk-2d0c53bb":"e865bc1d","chunk-2d0c85d9":"74ec0b06","chunk-2d0c90fc":"61cc703f","chunk-2d0d0219":"85f0e864","chunk-2d0e2742":"196cde5c","chunk-2d0e5b74":"cf7ff5e2","chunk-2d0f0bc5":"fca67adc","chunk-2d20847f":"8d51affc","chunk-2d210c47":"cb65a810","chunk-2d222737":"5799b02f","chunk-2d22fd16":"c599af11","chunk-2d23028a":"71ef2824","chunk-2f6fe07e":"73faad04","chunk-30d51d72":"784cf34b","chunk-321fb378":"b1a55031","chunk-6627076e":"60295793","chunk-68c6d461":"89ba5b4d","chunk-6ea8e0f2":"6c3d1977","chunk-7fd628b9":"e7544b23","chunk-8b9e36b4":"fc2b7878","chunk-b70a81bc":"ca130bd8","chunk-e966c272":"5f198332","chunk-eee7cf9e":"4b61b0b3","chunk-fca76dfa":"1a1b79f9","chunk-2d0ab08b":"310e96d2","chunk-2d230bb5":"04c8aad7","chunk-2d0c57a5":"1afa1d73","chunk-2d0e1ddd":"be4f3264","chunk-406dc664":"91a5e809","chunk-5b7a7548":"06e2d99d","chunk-8c86c6de":"a6a294d2","chunk-bf1cb0b0":"1434520e","chunk-2d0ac931":"cc71baa3","chunk-2d0c211b":"20162011","chunk-2d0cf315":"e659bcff","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"b8e77524","chunk-2d22895d":"060c8c65","chunk-2d23721e":"f4233577","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03b202f8":1,"chunk-19bd66b2":1,"chunk-27e95ab0":1,"chunk-e4733816":1,"chunk-2f6fe07e":1,"chunk-30d51d72":1,"chunk-6627076e":1,"chunk-68c6d461":1,"chunk-6ea8e0f2":1,"chunk-8b9e36b4":1,"chunk-b70a81bc":1,"chunk-e966c272":1,"chunk-eee7cf9e":1,"chunk-406dc664":1,"chunk-5b7a7548":1,"chunk-8c86c6de":1,"chunk-bf1cb0b0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"70ef055e","chunk-19bd66b2":"ef519537","chunk-2d0a3596":"31d6cfe0","chunk-2d0b2d29":"31d6cfe0","chunk-2d0b6969":"31d6cfe0","chunk-2d0c4d85":"31d6cfe0","chunk-16d3d0f6":"31d6cfe0","chunk-27e95ab0":"013a209e","chunk-2d0c7ca9":"31d6cfe0","chunk-e4733816":"41361c4e","chunk-2d0c53bb":"31d6cfe0","chunk-2d0c85d9":"31d6cfe0","chunk-2d0c90fc":"31d6cfe0","chunk-2d0d0219":"31d6cfe0","chunk-2d0e2742":"31d6cfe0","chunk-2d0e5b74":"31d6cfe0","chunk-2d0f0bc5":"31d6cfe0","chunk-2d20847f":"31d6cfe0","chunk-2d210c47":"31d6cfe0","chunk-2d222737":"31d6cfe0","chunk-2d22fd16":"31d6cfe0","chunk-2d23028a":"31d6cfe0","chunk-2f6fe07e":"185af1b9","chunk-30d51d72":"a37a5979","chunk-321fb378":"31d6cfe0","chunk-6627076e":"013a209e","chunk-68c6d461":"33dffe1a","chunk-6ea8e0f2":"3efffc2f","chunk-7fd628b9":"31d6cfe0","chunk-8b9e36b4":"5a01415b","chunk-b70a81bc":"3efd30a1","chunk-e966c272":"013a209e","chunk-eee7cf9e":"5a9b779d","chunk-fca76dfa":"31d6cfe0","chunk-2d0ab08b":"31d6cfe0","chunk-2d230bb5":"31d6cfe0","chunk-2d0c57a5":"31d6cfe0","chunk-2d0e1ddd":"31d6cfe0","chunk-406dc664":"4a036dda","chunk-5b7a7548":"c6758e74","chunk-8c86c6de":"282fdb38","chunk-bf1cb0b0":"471397aa","chunk-2d0ac931":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
